import { render, staticRenderFns } from "./DescriptionTable.vue?vue&type=template&id=34a0d0e0&scoped=true"
import script from "./DescriptionTable.vue?vue&type=script&lang=js"
export * from "./DescriptionTable.vue?vue&type=script&lang=js"
import style0 from "./DescriptionTable.vue?vue&type=style&index=0&id=34a0d0e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a0d0e0",
  null
  
)

export default component.exports